import { steps } from '../data/steps.module'
import '../App.css';
import { useEffect, useRef } from 'react'
import { useLocation, Link } from 'react-router-dom'
import { SetStateAction } from 'react';
import { setTextRange } from 'typescript';

export default function SideBarNav({}) {
   
    const location = useLocation();

    const count = useRef(0);

    let homeClass = "" ;
    let verifyclass = "";
    let personalinfo = "";
    let address = "";
    let payment = "";

    
    if (location.pathname =="/register")
    {
        verifyclass = "list-group-item";
        personalinfo ="list-group-item";
        address ="list-group-item";
        payment ="list-group-item";

    } else if (location.pathname=="/personal-lookup" || location.pathname=="/personal-lookup-verify")
    {   
        verifyclass = "list-group-item active";
        personalinfo ="list-group-item";
        address ="list-group-item";
        payment ="list-group-item";

    } else if (location.pathname=="/personal-info")
    {   
        verifyclass = "list-group-item active";
        personalinfo ="list-group-item active";
        address ="list-group-item";
        payment ="list-group-item";

    } else if (location.pathname=="/address")
    {   
        verifyclass = "list-group-item completed";
        personalinfo ="list-group-item completed";
        address ="list-group-item active";
        payment ="list-group-item";

    } else if (location.pathname=="/payment")
    {   
        verifyclass = "list-group-item completed";
        personalinfo ="list-group-item completed";
        address ="list-group-item completed";
        payment ="list-group-item active";

    } else {
        verifyclass = "list-group-item";
        personalinfo ="list-group-item";
        address ="list-group-item";
        payment ="list-group-item";
    }
   

 


    useEffect(() => {
        if (count.current !== 0) {
            //stop re-rendering of component
        }
        count.current++;
      }, [count])
    
    return (
        <div className='col-4 col-sm-4 col-md-5 col-lg-5 col-xl-5 col-xxl-5 mt-5 pt-3'>
        <div className='sidebar_image'>
            <div className='nav_frame'>
           
            <h2 className='text-start fs-5 fw-light'><Link to="/" className='text-decoration-none'>START OVER</Link></h2>
           
            <div className="step_container mx-auto">
            <div className="col-5 col-sm-5 pt-2 mt-5">
                <ul className="list-group vertical-steps list-group-flush">
                
                    <li className={verifyclass} key="2">
                        PERSONAL INFO
                    </li>
                    <li className={address} key="3">
                       ADDRESS
                    </li>
                    <li className={payment} key="4">
                       REVIEW & PAY
                    </li>
                    </ul>
                </div>
            </div>
            </div>
        </div>
            
        </div>
)
}